import React, { useEffect, useState, useRef } from 'react';
import { ChevronDownIcon, MapPinnedIcon, MenuIcon, SearchIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
type NavigationItem = {
  label: string;
  to: string;
};
type NavigationGroup = {
  label: string;
  items: NavigationItem[];
};
const navigationGroups: NavigationGroup[] = [{
  label: 'Tours',
  items: [{
    label: 'Honeymoon Tours',
    to: '/tours/honeymoon'
  }, {
    label: 'Cultural Tours',
    to: '/tours/honeymoon'
  }, {
    label: 'Wildlife Tours',
    to: '/tours/honeymoon'
  }]
}, {
  label: 'Treks',
  items: [{
    label: 'Everest Treks',
    to: '/treks/everest'
  }, {
    label: 'Annapurna Treks',
    to: '/treks/everest'
  }, {
    label: 'Manaslu Circuit Trek',
    to: '/treks/manaslu-circuit'
  }]
}, {
  label: 'Guide',
  items: [{
    label: 'Guide name',
    to: '/guides'
  }, {
    label: 'Nepal',
    to: '/guides'
  }, {
    label: 'Everest',
    to: '/guides'
  }, {
    label: 'Pokhara',
    to: '/guides'
  }, {
    label: 'Annapurna',
    to: '/guides'
  }, {
    label: 'Langtang',
    to: '/guides'
  }]
}, {
  label: 'Company',
  items: [{
    label: 'About Us',
    to: '/about'
  }, {
    label: 'Explore Our Team',
    to: '/company/team'
  }, {
    label: 'Why Choose Us',
    to: '/company/why-choose-us'
  }, {
    label: 'CSR',
    to: '/company/csr'
  }, {
    label: 'Legal Documents',
    to: '/company/legal-documents'
  }, {
    label: 'Terms and Conditions',
    to: '/company/terms-and-conditions'
  }, {
    label: 'Awards and Achievement',
    to: '/company/awards'
  }, {
    label: 'Customer Reviews',
    to: '/company/customer-reviews'
  }, {
    label: 'Video Reviews',
    to: '/company/video-reviews'
  }, {
    label: 'Partner with us',
    to: '/company/partner-with-us'
  }, {
    label: 'Blogs',
    to: '/guides'
  }]
}];
const searchDestinations = [{
  label: 'Manaslu Circuit Trek',
  to: '/treks/manaslu-circuit'
}, {
  label: 'Everest Treks',
  to: '/treks/everest'
}, {
  label: 'Honeymoon Tours',
  to: '/tours/honeymoon'
}, {
  label: 'Nepal travel guides',
  to: '/guides'
}, {
  label: 'Nepal travel planning guide',
  to: '/guides/nepal-travel-guide'
}, {
  label: 'About Tour in Nepal',
  to: '/about'
}, {
  label: 'Plan a trip',
  to: '/contact#plan-trip'
}];
export function Header() {
  const [openGroup, setOpenGroup] = useState<string | null>(null);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [openMobileGroup, setOpenMobileGroup] = useState<string | null>(null);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const searchInputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (isSearchOpen) {
      searchInputRef.current?.focus();
    }
  }, [isSearchOpen]);
  const closeAll = () => {
    setOpenGroup(null);
    setIsMobileOpen(false);
    setOpenMobileGroup(null);
  };
  const closeSearch = () => {
    setIsSearchOpen(false);
    setSearchQuery('');
  };
  const openSearch = () => {
    closeAll();
    setIsSearchOpen(true);
  };
  const matchingDestinations = searchDestinations.filter(destination => destination.label.toLowerCase().includes(searchQuery.toLowerCase()));
  return <header className="relative z-50 border-b border-stone-200 bg-stone-50 text-stone-900" data-id="element-208">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 sm:px-8 lg:px-12" data-id="element-209">
        <Link to="/" className="inline-flex items-center gap-2.5 font-semibold tracking-[0.13em] focus:outline-none focus:ring-2 focus:ring-[#20362f] focus:ring-offset-4" aria-label="TOUR IN NEPAL home" onClick={closeAll} data-id="element-210">
          <MapPinnedIcon className="h-5 w-5 text-[#596f3b]" aria-hidden="true" data-id="element-211" />
          <span className="text-sm sm:text-base" data-id="element-212">TOUR IN NEPAL</span>
        </Link>

        <nav className="primary-navigation hidden items-center gap-4 xl:gap-6 lg:flex" aria-label="Primary navigation" data-id="element-213">
          {navigationGroups.map(group => {
          const isOpen = openGroup === group.label;
          return <div key={group.label} className="relative" data-id="element-214">
                <button type="button" className="inline-flex items-center gap-1.5 py-2 text-sm font-medium text-stone-700 transition-colors hover:text-[#596f3b] focus:outline-none focus:ring-2 focus:ring-[#20362f] focus:ring-offset-4" aria-expanded={isOpen} aria-haspopup="true" onClick={() => setOpenGroup(isOpen ? null : group.label)} onKeyDown={event => {
              if (event.key === 'Escape') setOpenGroup(null);
            }} data-id="element-215">
                  {group.label}
                  <ChevronDownIcon className={`h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-216" />
                </button>

                {isOpen && <div className="absolute left-0 top-full w-56 border border-stone-200 bg-white py-2 shadow-lg" data-id="element-217">
                    {group.items.map(item => <Link key={item.label} to={item.to} className="block px-4 py-2.5 text-sm text-stone-700 transition-colors hover:bg-stone-100 hover:text-[#20362f] focus:bg-stone-100 focus:outline-none" onClick={closeAll} data-id="element-218">
                        {item.label}
                      </Link>)}
                  </div>}
              </div>;
        })}

          <Link to="/contact" className="text-sm font-medium text-stone-700 transition-colors hover:text-[#596f3b] focus:outline-none focus:ring-2 focus:ring-[#20362f] focus:ring-offset-4" onClick={closeAll} data-id="element-219">
            Contact
          </Link>
          <button type="button" className="inline-flex h-10 w-10 items-center justify-center border border-stone-300 text-stone-700 transition-colors hover:border-[#596f3b] hover:text-[#20362f] focus:outline-none focus:ring-2 focus:ring-[#20362f] focus:ring-offset-2" aria-label="Search trips and guides" aria-haspopup="dialog" aria-expanded={isSearchOpen} onClick={openSearch} data-id="element-220">
            <SearchIcon className="h-4 w-4" aria-hidden="true" data-id="element-221" />
          </button>
          <Link to="/contact#plan-trip" className="bg-[#17362e] px-4 py-3 text-[10px] font-bold uppercase tracking-[0.15em] text-white transition-colors hover:bg-[#315c3b] focus:outline-none focus:ring-2 focus:ring-[#20362f] focus:ring-offset-4" onClick={closeAll} data-id="element-222">
            Plan a Trip
          </Link>
        </nav>

        <button type="button" className="inline-flex items-center justify-center p-2 text-stone-800 focus:outline-none focus:ring-2 focus:ring-[#20362f] focus:ring-offset-2 lg:hidden" aria-label={isMobileOpen ? 'Close navigation menu' : 'Open navigation menu'} aria-expanded={isMobileOpen} onClick={() => setIsMobileOpen(!isMobileOpen)} data-id="element-223">
          {isMobileOpen ? <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-224" /> : <MenuIcon className="h-6 w-6" aria-hidden="true" data-id="element-225" />}
        </button>
      </div>

      {isMobileOpen && <nav className="border-t border-stone-200 bg-stone-50 px-5 py-4 lg:hidden" aria-label="Mobile primary navigation" data-id="element-226">
          <div className="mx-auto max-w-7xl" data-id="element-227">
            {navigationGroups.map(group => {
          const isOpen = openMobileGroup === group.label;
          return <div key={group.label} className="border-b border-stone-200 py-1" data-id="element-228">
                  <button type="button" className="flex w-full items-center justify-between py-3 text-left text-base font-medium text-stone-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#20362f]" aria-expanded={isOpen} onClick={() => setOpenMobileGroup(isOpen ? null : group.label)} data-id="element-229">
                    {group.label}
                    <ChevronDownIcon className={`h-5 w-5 transition-transform ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-230" />
                  </button>

                  {isOpen && <div className="pb-3 pl-4" data-id="element-231">
                      {group.items.map(item => <Link key={item.label} to={item.to} className="block py-2 text-sm text-stone-600 focus:outline-none focus:underline" onClick={closeAll} data-id="element-232">
                          {item.label}
                        </Link>)}
                    </div>}
                </div>;
        })}

            <Link to="/contact" className="block border-b border-stone-200 py-4 text-base font-medium text-stone-900 focus:outline-none focus:underline" onClick={closeAll} data-id="element-233">
              Contact
            </Link>
            <button type="button" className="flex w-full items-center gap-3 border-b border-stone-200 py-4 text-left text-base font-medium text-stone-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#20362f]" onClick={openSearch} data-id="element-234">
              <SearchIcon className="h-5 w-5" aria-hidden="true" data-id="element-235" />
              Search trips and guides
            </button>
            <Link to="/contact#plan-trip" className="mt-5 block bg-[#17362e] px-5 py-4 text-center text-[10px] font-bold uppercase tracking-[0.16em] text-white focus:outline-none focus:ring-2 focus:ring-[#20362f] focus:ring-offset-2" onClick={closeAll} data-id="element-236">
              Plan a Trip
            </Link>
          </div>
        </nav>}

      {isSearchOpen && <div className="fixed inset-0 z-[60] flex items-start justify-center bg-[#112a23]/70 px-5 pt-24 sm:pt-32" role="presentation" onMouseDown={event => {
      if (event.target === event.currentTarget) closeSearch();
    }} data-id="element-237">
          <section className="w-full max-w-xl border border-[#cfd3c8] bg-[#f8f5ed] p-5 shadow-2xl sm:p-7" role="dialog" aria-modal="true" aria-labelledby="search-dialog-title" onKeyDown={event => {
        if (event.key === 'Escape') closeSearch();
      }} data-id="element-238">
            <div className="flex items-start justify-between gap-4" data-id="element-239">
              <div data-id="element-240">
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#a66e2e]" data-id="element-241">
                  Find your way
                </p>
                <h2 id="search-dialog-title" className="mt-2 font-serif text-2xl text-[#17362e]" data-id="element-242">
                  Search journeys and guides
                </h2>
              </div>
              <button type="button" className="flex h-10 w-10 items-center justify-center border border-stone-300 text-stone-700 transition-colors hover:border-[#17362e] hover:text-[#17362e] focus:outline-none focus:ring-2 focus:ring-[#20362f]" aria-label="Close search" onClick={closeSearch} data-id="element-243">
                <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-244" />
              </button>
            </div>

            <form className="mt-6" role="search" onSubmit={event => event.preventDefault()} data-id="element-245">
              <label htmlFor="header-search" className="sr-only" data-id="element-246">
                Search trips and guides
              </label>
              <div className="flex items-center border-b border-[#708075] pb-2" data-id="element-247">
                <SearchIcon className="mr-3 h-5 w-5 text-[#52635a]" aria-hidden="true" data-id="element-248" />
                <input ref={searchInputRef} id="header-search" type="search" value={searchQuery} onChange={event => setSearchQuery(event.target.value)} placeholder="Try Everest, Manaslu, or guides" className="w-full bg-transparent text-base text-[#17362e] placeholder:text-[#718074] focus:outline-none" data-id="element-249" />
              </div>
            </form>

            <div className="mt-6" data-id="element-250">
              <p className="text-[10px] font-bold uppercase tracking-[0.17em] text-[#718074]" data-id="element-251">
                {searchQuery ? 'Matching pages' : 'Popular pages'}
              </p>
              <div className="mt-3 divide-y divide-[#d5d8cc] border-y border-[#d5d8cc]" data-id="element-252">
                {matchingDestinations.length > 0 ? matchingDestinations.map(destination => <Link key={destination.label} to={destination.to} className="flex items-center justify-between py-3 text-sm font-medium text-[#17362e] transition-colors hover:text-[#4f8057] focus:outline-none focus:underline" onClick={closeSearch} data-id="element-253">
                      {destination.label}
                      <span aria-hidden="true" data-id="element-254">↗</span>
                    </Link>) : <p className="py-4 text-sm text-[#52635a]" data-id="element-255">
                    No matching journeys yet. Try a mountain region or guide
                    topic.
                  </p>}
              </div>
            </div>
          </section>
        </div>}
    </header>;
}